<template>
  <button class="icon-button" v-on="$listeners">
    <span class="custom-icon icon-button__icon icon-cross-graphite"></span>
  </button>
</template>

<script>
export default {
  name: 'CloseButton'
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/icon.scss';

.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--button-size, 32px);
  width: var(--button-size, 32px);

  background-color: transparent;
  border-radius: 50%;
  border: 1px solid var(--u-color-grey-400);
  outline: none;
  cursor: pointer;

  &__icon {
    width: var(--icon-size, 8px);
    height: var(--icon-size, 8px);
  }
}
</style>
